// LocalStorage Enum
export enum StorageItem {
	// Authentication Bearer Token
	token = 'token',
}
